var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: _vm.customHtmlClasses,
              expression: "customHtmlClasses"
            }
          ],
          staticClass: "overlay-childproducts",
          class: {
            "overlay-childproducts--show-summary": _vm.showSummary
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "overlay-childproducts__close",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                }
              }
            },
            [_c("SVGClose")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overlay-childproducts__wrapper" }, [
            _c(
              "div",
              { staticClass: "overlay-childproducts__content" },
              [
                _vm._l(
                  Object.entries(_vm.childProductCategoriesGrouped),
                  function(ref) {
                    var type = ref[0]
                    var categories = ref[1]
                    return _c(
                      "div",
                      {
                        key: type,
                        staticClass: "overlay-childproducts__content-block"
                      },
                      [
                        categories.length
                          ? _c("h1", {
                              staticClass: "overlay-childproducts__title",
                              class: ["overlay-childproducts__title--" + type],
                              domProps: {
                                innerHTML: _vm._s(_vm.stepTitle[type])
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.stepDescription[type]
                          ? _c("div", {
                              directives: [
                                {
                                  name: "sanitize",
                                  rawName: "v-sanitize",
                                  value: _vm.stepDescription[type],
                                  expression: "stepDescription[type]"
                                }
                              ],
                              staticClass: "overlay-childproducts__description"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(categories, function(category, index) {
                          return _c(
                            "Collapsible",
                            {
                              key: category.id,
                              staticClass: "overlay-childproducts__category",
                              attrs: { "initial-open": "" }
                            },
                            [
                              _c("template", { slot: "trigger" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "overlay-childproducts__category-title"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(category.name)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("small", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.categoryHint(category)
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "overlay-childproducts__category-preview"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "overlay-childproducts__category-preview-list"
                                      },
                                      _vm._l(
                                        _vm.categoryPreview(category),
                                        function(child) {
                                          return _c(
                                            "li",
                                            {
                                              key: child.code,
                                              staticClass:
                                                "overlay-childproducts__category-preview-item"
                                            },
                                            [
                                              child.imageMood || child.image
                                                ? _c("img", {
                                                    staticClass:
                                                      "overlay-childproducts__category-preview-item-image",
                                                    class: {
                                                      "overlay-childproducts__category-preview-item-image--wide":
                                                        child.imageMood
                                                    },
                                                    attrs: {
                                                      src:
                                                        child.imageMood ||
                                                        child.image,
                                                      alt:
                                                        child.shortDescription
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "overlay-childproducts__category-preview-item-name",
                                                domProps: {
                                                  innerHTML: _vm._s(child.name)
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors[category.code]
                                  ? _c("div", {
                                      staticClass:
                                        "overlay-childproducts__category-error",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.errors[category.code]
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "overlay-childproducts__items" },
                                _vm._l(category.products, function(child) {
                                  return _c(
                                    "li",
                                    {
                                      key: child.code,
                                      staticClass:
                                        "overlay-childproducts__item",
                                      class: {
                                        "overlay-childproducts__item--checked":
                                          _vm.selectedMap[child.code]
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "overlay-childproducts__item-label"
                                        },
                                        [
                                          _c("input", {
                                            staticClass:
                                              "overlay-childproducts__item-input",
                                            attrs: {
                                              type: "checkbox",
                                              name: category.code,
                                              immediate: ""
                                            },
                                            domProps: {
                                              value: child.code,
                                              checked:
                                                _vm.selectedMap[child.code]
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onItemChange(
                                                  child,
                                                  category
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          child.imageMood || child.image
                                            ? _c(
                                                "figure",
                                                {
                                                  staticClass:
                                                    "overlay-childproducts__item-image"
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "overlay-childproducts__item-image-element",
                                                    class: {
                                                      "overlay-childproducts__item-image-element--wide":
                                                        child.imageMood
                                                    },
                                                    attrs: {
                                                      src:
                                                        child.imageMood ||
                                                        child.image,
                                                      alt:
                                                        child.shortDescription,
                                                      loading: "lazy"
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "overlay-childproducts__item-content"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "overlay-childproducts__item-name",
                                                domProps: {
                                                  innerHTML: _vm._s(child.name)
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "overlay-childproducts__item-price"
                                                },
                                                [
                                                  child.originalPrice >
                                                  child.price
                                                    ? _c("strike", {
                                                        staticClass:
                                                          "overlay-childproducts__item-price-old",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.formatItemPrice(
                                                              child.originalPrice
                                                            )
                                                          )
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "overlay-childproducts__item-price-current",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formatItemPrice(
                                                          child.price
                                                        )
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.priceReduction(child)
                                                ? _c("div", {
                                                    staticClass:
                                                      "overlay-childproducts__item-price-reduction",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.priceReduction(
                                                          child
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ],
                            2
                          )
                        })
                      ],
                      2
                    )
                  }
                ),
                _vm._v(" "),
                !_vm.options.length && !_vm.extras.length
                  ? _c("div", {
                      staticClass: "overlay-childproducts__empty",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("childproducts.noOptions"))
                      }
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-childproducts__summary" },
              [
                _c(
                  "div",
                  { staticClass: "overlay-childproducts__summary-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "overlay-childproducts__summary-product" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "overlay-childproducts__summary-product-title"
                          },
                          [
                            _c("h3", {
                              staticClass:
                                "overlay-childproducts__summary-product-name",
                              domProps: { innerHTML: _vm._s(_vm.item.name) }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "overlay-childproducts__summary-product-price",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgpricecent(
                                    _vm.item.price,
                                    "short"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.variantName
                          ? _c("div", {
                              staticClass:
                                "overlay-childproducts__summary-product-options",
                              domProps: { innerHTML: _vm._s(_vm.variantName) }
                            })
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "overlay-childproducts__summary-content overlay-childproducts__summary-scroll"
                  },
                  [
                    _vm._l(_vm.selectedItemsByCategory, function(
                      category,
                      index
                    ) {
                      return [
                        _c("h2", {
                          staticClass: "overlay-childproducts__summary-title",
                          domProps: { innerHTML: _vm._s(category.name) }
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "overlay-childproducts__summary-extras"
                          },
                          _vm._l(category.products, function(extra) {
                            return _c(
                              "li",
                              {
                                key: "summary-extra-" + extra.code,
                                staticClass:
                                  "overlay-childproducts__summary-extra"
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "overlay-childproducts__summary-extra-name",
                                  domProps: { innerHTML: _vm._s(extra.name) }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass:
                                    "overlay-childproducts__summary-extra-price",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatItemPrice(extra.price)
                                    )
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "overlay-childproducts__summary-content overlay-childproducts__summary-total"
                  },
                  [
                    _c("span", {
                      staticClass: "overlay-childproducts__summary-total-title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("childproducts.total"))
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "overlay-childproducts__summary-total-price",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(_vm.total, "short")
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("Button", {
                  staticClass:
                    "overlay-childproducts__summary-button overlay-childproducts__summary-button--desktop",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.buttonText
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onButtonClick()
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  staticClass:
                    "overlay-childproducts__summary-button overlay-childproducts__summary-button--mobile",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.$t("childproducts.backButton")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onCloseSummary()
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-childproducts__sticky" },
              [
                _c(
                  "div",
                  {
                    staticClass: "overlay-childproducts__sticky-details",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onOpenSummary()
                      }
                    }
                  },
                  [
                    _c("Button", {
                      staticClass:
                        "overlay-childproducts__sticky-details-button",
                      attrs: {
                        type: "button",
                        level: "tertiary",
                        text: _vm.countButtonText,
                        arrow: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "overlay-childproducts__sticky-details-total",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(_vm.total)
                        )
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("Button", {
                  staticClass: "overlay-childproducts__sticky-button",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.buttonText
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onButtonClick()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }